import { AnyAction, Reducer } from "redux";

import { GlanceState } from "./definitions";
import { ACTION_GLANCE_CONNECT, ACTION_GLANCE_RESET, ACTION_START_SESSION } from "./actions/actionTypes";

const initialState: GlanceState = {};

export const GlanceReducer: Reducer = (state: GlanceState = initialState, action: AnyAction): GlanceState => {
    switch (action.type) {
        case ACTION_START_SESSION: {
            return {
                ...state,
                visitor: action.payload.glanceVisitor
            };
        }

        case ACTION_GLANCE_CONNECT: {
            return {
                ...state,
                isConnected: true
            };
        }

        case ACTION_GLANCE_RESET: {
            return {
                ...state,
                visitor: undefined,
                isConnected: false
            };
        }

        default:
            return state;
    }
};
